
export type PermissionNames =
  'View Users' | 'Manage Users' |
  'View Roles' | 'Manage Roles' | 'Assign Roles' |
  'View loading' | 'Manage Loading' | 'Manage TLR' |
  'Approve Quotation' | 'Super Admin' | 'theme.access' | 'Allow Special Request' |
  'Individual Quotation'
  ;

export type PermissionValues =
  'users.view' | 'users.manage' |
  'roles.view' | 'roles.manage' | 'roles.assign' |
  'loading.view' | 'loading.manage' | 'tlr.manage' |
  'quotation.tlr' | 'quotation.view' | 'quotation.approve' | 'superadmin' |
  'theme.access' | 'loading.brk' | 'loading.ins' | 'loading.tpa' | 'loading.tpafee' |
  'quotation.policyfee' | 'quotation.tax' | 'approval.nrploading' | 'approval.claimexpfactor' | 'quotation.spclreq'
  | 'comparator' | 'offerdoc.edit' | 'app.health' | 'app.life' | 'quotation.emergfee' | 'quotation.dhamanifee' | 'health.group' | 'health.individual'
  ;
export type ServicePermissionValues =
  'users.view' | 'users.manage' |
  'roles.view' | 'roles.manage' | 'roles.assign' |
  'loading.view' | 'health.loading.manage' | 'life.loading.manage' | 'tlr.manage' |
  'health.quotation.tlr' | 'life.quotation.tlr' | 'health.quotation.view' | 'life.quotation.view' | 'health.quotation.approve' | 'life.quotation.approve' | 'superadmin' |
  'theme.access' | 'health.loading.brk' | 'life.loading.brk' | 'health.loading.ins' | 'life.loading.ins' | 'health.loading.tpa' | 'life.loading.tpa' | 'health.loading.tpafee' | 'life.loading.tpafee' |
  'health.quotation.policyfee' | 'life.quotation.policyfee' | 'health.quotation.tax' | 'life.quotation.tax' | 'health.approval.nrploading' | 'life.approval.nrploading' |
  'health.approval.claimexpfactor' | 'life.approval.claimexpfactor' | 'health.quotation.spclreq' | 'life.quotation.spclreq'
  | 'health.comparator' | 'life.comparator' | 'health.offerdoc.edit' | 'life.offerdoc.edit' | 'health.quotation.emergfee' | 'health.individual' | 'health.group' | 'life.quotation.emergfee' | 'life.quotation.individual' | 'life.quotation.individualOnly'
  | 'health.quotation.dhamanifee' | 'life.quotation.dhamanifee';
export class Permission {
  //User Management
  public static readonly viewUsers: PermissionValues = 'users.view';
  public static readonly manageUsers: PermissionValues = 'users.manage';
  public static readonly viewRoles: PermissionValues = 'roles.view';
  public static readonly manageRoles: PermissionValues = 'roles.manage';
  public static readonly assignRoles: PermissionValues = 'roles.assign';

  //Loading Permission
  public static readonly viewGrossLoading: PermissionValues = 'loading.view';
  public static readonly manageGrossLoading: PermissionValues = 'loading.manage';
  public static readonly manageBrkLoading: PermissionValues = 'loading.brk';
  public static readonly manageInsLoading: PermissionValues = 'loading.ins';
  public static readonly manageTpaLoading: PermissionValues = 'loading.tpa';
  public static readonly manageTpaFee: PermissionValues = 'loading.tpafee';

  //Quotation Permission
  public static readonly quotationTLR: PermissionValues = 'quotation.tlr';
  public static readonly quotationTax: PermissionValues = 'quotation.tax';
  public static readonly quotationEmergencyFee: PermissionValues = 'quotation.emergfee'; // emergency fee for visitors
  public static readonly quotationDhamaniFee: PermissionValues = 'quotation.dhamanifee'; // dhamani fee for visitors
  public static readonly quotationPolicyFee: PermissionValues = 'quotation.policyfee';
  public static readonly quotationSpclReq: PermissionValues = 'quotation.spclreq';

  //Quotation Offer Document Edit Permission
  public static readonly editOfferDoc: PermissionValues = 'offerdoc.edit';

  //Approval Permission
  public static readonly approveQuotation: PermissionValues = 'quotation.approve';
  public static readonly approvalNRPLoading: PermissionValues = 'approval.nrploading';
  public static readonly approvalClaimExpFactor: PermissionValues = 'approval.claimexpfactor';

  //Individual Quote Permission
  public static readonly individualQuotation: PermissionValues = 'health.individual';
  public static readonly groupQuotation: PermissionValues = 'health.group';
  
  public static readonly viewQuotation: PermissionValues = 'quotation.view';
  public static readonly viewComparatorUI: PermissionValues = 'comparator';

  public static readonly IsSuperAdmin: PermissionValues = 'superadmin';
  public static readonly themeAccess: PermissionValues = 'theme.access';


  constructor(name?: PermissionNames, value?: PermissionValues, groupName?: string, description?: string) {
    this.name = name;
    this.value = value;
    this.groupName = groupName;
    this.description = description;
  }

  public name: PermissionNames;
  public value: PermissionValues;
  public groupName: string;
  public description: string;
}
